import React from 'react';
import styled from 'styled-components';
import { Divider, Pagination as APagination } from 'antd';
import { LeftCircleOutlinedIcon, RightCircleOutlinedIcon } from 'components/Icons';

const StyledPagination = styled(APagination)`
    .ant-pagination-item {
        color: ${({ theme }) => theme.colors.greyishBrown};
        border: none;
    }
    .ant-pagination-item-active {
        font-weight: bold;
    }
    .anticon {
        color: ${({ theme }) => theme.colors.primary};
    }
`;

interface IconProps {
    disabled: boolean;
    fontSize: number;
}

const RightCircleOutlined = styled(RightCircleOutlinedIcon)<IconProps>`
    svg {
        vertical-align: -0.125em;
    }
    color: ${({ theme, disabled }) =>
        disabled ? 'rgba(0, 0, 0, 0.25)' : theme.colors.primary} !important;
    font-size: ${({ fontSize }) => `${fontSize}px`};
`;

const LeftCircleOutlined = styled(LeftCircleOutlinedIcon)<IconProps>`
    svg {
        vertical-align: -0.125em;
    }
    color: ${({ theme, disabled }) =>
        disabled ? 'rgba(0, 0, 0, 0.25)' : theme.colors.primary} !important;
    font-size: ${({ fontSize }) => `${fontSize}px`};
`;

interface Props {
    currentPage: number;
    results: number;
    onChange: (page: number) => void;
    pageSize?: number;
    next: boolean;
    prev: boolean;
    fontSize?: number;
}

const Pagination = ({
    currentPage,
    results,
    onChange,
    pageSize = 20,
    next = true,
    prev = true,
    fontSize = 26
}: Props): JSX.Element => {
    if (results < pageSize) {
        return null;
    }

    return (
        <Divider>
            <StyledPagination
                current={currentPage}
                onChange={onChange}
                total={results}
                pageSize={pageSize}
                hideOnSinglePage
                showSizeChanger={false}
                itemRender={(page, type, originalElement) => {
                    if (type === 'jump-prev' || type === 'jump-next') {
                        return originalElement;
                    }

                    if (type === 'prev') {
                        return <LeftCircleOutlined fontSize={fontSize} disabled={!prev} />;
                    }
                    if (type === 'next') {
                        return <RightCircleOutlined fontSize={fontSize} disabled={!next} />;
                    }
                    return page;
                }}
            />
        </Divider>
    );
};

export default Pagination;
